import { useEffect, useState } from 'react'
import axios from 'axios'

export default function useDurationSearch(songs) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [maxDuration, setMaxDuration] = useState(0)

  useEffect(() => {
    setLoading(true)
    setError(false)

    // Fetch duration for each song and update maxDuration
    Promise.all(
      songs.map(song => {
        // Remove last 3 characters (file extension) and append ".txt"
        const fileName = song.rel_path.slice(0, -3) + 'txt';
        return axios.get(`https://starboxkod.com/${song.server_id}/${fileName}`)
          .then(response => parseFloat(response.data))
          .catch(error => {
            console.error(`Error fetching duration for ${song.server_id}/${fileName}: ${error}`)
            return 0
          });
      })
    ).then(durations => {
      const max = Math.max(...durations)
      setMaxDuration(max)
      setLoading(false)
    }).catch(error => {
      console.error('Error fetching durations:', error)
      setError(true)
    })
  }, [songs])

  return { loading, error, maxDuration }
}
